import { createTheme, ThemeOptions } from "@mui/material/styles"
import themeComponents from "./theme-components"

const colors = {
  primaryMain: "#0F172A",
  primaryContrastText: "#ffffff",
  secondaryMain: "#E2E8F0",
  secondaryContrastText: "#0F172A",
  errorMain: "#FA897B",
  successMain: "#D0E6AS",
  warningMain: "#FFDD94",
  infoMain: "#B6E3CE",
  textPrimary: "#0F172A",
  textSecondary: "#B3B3B3",
  textDisabled: "#9CA3AF",
  divider: "#CBD5E1",
  backgroundDefault: "#ffffff",
  actionHover: "#E2E8F0",
  actionSelected: "#F1F5F9",
  sidebarMain: "#334155",
  sidebarContrastText: "#334155",
  tableFontSize: "0.875rem"
}

const lightTheme: ThemeOptions = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: colors.primaryMain,
      contrastText: colors.primaryContrastText
    },
    secondary: {
      main: colors.secondaryMain,
      contrastText: colors.secondaryContrastText
    },
    error: {
      main: colors.errorMain
    },
    success: {
      main: colors.successMain
    },
    info: {
      main: colors.infoMain
    },
    warning: {
      main: colors.warningMain
    },
    background: {
      default: colors.backgroundDefault,
      paper: colors.backgroundDefault
    },
    text: {
      primary: colors.textPrimary,
      secondary: colors.textSecondary,
      disabled: colors.textDisabled
    },
    divider: colors.divider,
    action: {
      hover: colors.actionHover,
      selected: colors.actionSelected
    },
    neutral: {
      light: colors.backgroundDefault,
      dark: colors.secondaryContrastText,
      main: colors.secondaryMain,
      contrastText: colors.primaryContrastText
    },
    grey: {
      500: colors.secondaryContrastText
    },
    sidebar: {
      main: colors.sidebarMain,
      contrastText: colors.sidebarContrastText,
      hover: colors.actionSelected,
      submenuBackground: colors.secondaryMain,
      active: colors.actionSelected
    },
    table: {
      headerColor: colors.secondaryContrastText,
      headerBackground: colors.secondaryMain,
      color: colors.primaryMain,
      background: colors.secondaryMain,
      active: colors.actionSelected,
      border: colors.divider,
      fontSize: colors.tableFontSize
    },
    scrollbar: {
      thumb: colors.secondaryContrastText,
      track: colors.secondaryMain
    }
  },
  typography: {
    fontFamily: `'Poppins',"Lato", "Inter",Roboto, sans-serif`,
    h1: { fontSize: "1.575rem", fontWeight: 700, lineHeight: 1.5 },
    h2: { fontSize: "1.35rem", fontWeight: 600, lineHeight: 1.4 },
    h3: { fontSize: "1.125rem", fontWeight: 600, lineHeight: 1.3 },
    h4: { fontSize: "1.035rem", fontWeight: 600, lineHeight: 1.3 },
    h5: { fontSize: "0.9rem", fontWeight: 600, lineHeight: 1.3 },
    body1: { fontSize: "0.9rem", fontWeight: 400, lineHeight: 1.5 },
    body2: { fontSize: "0.7875rem", fontWeight: 400, lineHeight: 1.4 },
    subtitle1: { fontSize: "0.675rem", fontWeight: 400, lineHeight: 1.3 },
    subtitle2: { fontSize: "0.5625rem", fontWeight: 400, lineHeight: 1.2 },
    caption: { fontSize: "0.45rem", fontWeight: 400, lineHeight: 1.1 }
  },
  components: themeComponents
})

export default lightTheme
